import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { SIDES } from '../constants.js';
import { calcSide, POPOVER_COMPONENT_NAMES } from '../../utils/popoverPosition.js';

var _mapSideToPlacement;
var mapSideToPlacement = (_mapSideToPlacement = {}, _defineProperty(_mapSideToPlacement, SIDES.TOP, 'top'), _defineProperty(_mapSideToPlacement, SIDES.TOP_LEFT, 'top-end'), _defineProperty(_mapSideToPlacement, SIDES.TOP_RIGHT, 'top-start'), _defineProperty(_mapSideToPlacement, SIDES.BOTTOM, 'bottom'), _defineProperty(_mapSideToPlacement, SIDES.BOTTOM_LEFT, 'bottom-end'), _defineProperty(_mapSideToPlacement, SIDES.BOTTOM_RIGHT, 'bottom-start'), _defineProperty(_mapSideToPlacement, SIDES.RIGHT, 'right-start'), _mapSideToPlacement); // Calculate offset values for react-popper
// This needs to be defined in a function outside the Tooltip component, to avoid an infinite rerender from react-popper
// https://popper.js.org/react-popper/v2/faq/#why-i-get-render-loop-whenever-i-put-a-function-inside-the-popper-configuration

var calcOffset = function calcOffset(_ref) {
  var placement = _ref.placement;

  var _placement$split = placement.split('-'),
      _placement$split2 = _slicedToArray(_placement$split, 2),
      position = _placement$split2[0],
      variation = _placement$split2[1]; // "skid" and "distance" are the terms used by popper
  // https://popper.js.org/docs/v2/modifiers/offset/


  var distanceOffset;

  if (position === 'top') {
    distanceOffset = 10;
  } else if (position === 'bottom') {
    distanceOffset = 15;
  } else {
    distanceOffset = 12;
  }

  var skidOffset;

  if (variation === 'start') {
    skidOffset = -20;
  } else if (variation === 'end') {
    skidOffset = 20;
  } else {
    skidOffset = 0;
  }

  return [skidOffset, distanceOffset];
};
var createPopperConfig = function createPopperConfig(toggleNode, arrowNode, side, bubbleWidth) {
  var modifiers = [{
    name: 'arrow',
    options: {
      element: arrowNode
    }
  }, {
    name: 'offset',
    options: {
      offset: calcOffset
    }
  }, // NOTE: The following are features we could consider enabling in the future, pending design team approval
  // For now, they're disabled to preserve existing behaviour
  {
    name: 'preventOverflow',
    options: {
      mainAxis: false,
      altAxis: false
    }
  }, {
    name: 'flip',
    enabled: false
  }];
  var mappedSide = mapSideToPlacement[side];

  if (mappedSide) {
    return {
      modifiers: modifiers,
      placement: mappedSide
    };
  }

  if (toggleNode) {
    var bounds = toggleNode.getBoundingClientRect();
    var x = bounds.x,
        y = bounds.y;
    var placement = mapSideToPlacement[calcSide(window.innerWidth, window.innerHeight, x, y, bubbleWidth, POPOVER_COMPONENT_NAMES.TOOLTIP)];
    return {
      modifiers: modifiers,
      placement: placement
    };
  }

  return {
    modifiers: modifiers
  };
};

export { calcOffset, createPopperConfig };
